import { LoginRequest, LoginResult } from "@t3/shared";
import { createHttpsCallableHook } from "./createHttpsCallableHook";

const middlewareOnCallLoginRequest = (request: LoginRequest) => {
  if (!request.email) {
    throw new Error("Email is required");
  }
  return request;
};

export const useLoginUser = createHttpsCallableHook<LoginRequest, LoginResult>(
  "loginUser",
  middlewareOnCallLoginRequest,
);
